import { render, staticRenderFns } from "./msgView.vue?vue&type=template&id=09c9f1aa&scoped=true"
import script from "./msgView.vue?vue&type=script&lang=js"
export * from "./msgView.vue?vue&type=script&lang=js"
import style0 from "./msgView.vue?vue&type=style&index=0&id=09c9f1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c9f1aa",
  null
  
)

export default component.exports